import { EnvBanner, isProduction } from 'noddi-web';
import { useStationaryGarages } from '../../hooks/useStationaryGarages';

/**
 * Customer env banner: when the active brand has adapter-enabled stationary
 * departments, append adapter type + API env (test|prod) so testers know
 * which provider outbound hits.
 */
export const CustomerEnvBanner = () => {
  // Capacity not needed — only whether any garage is adapter-backed. Banner
  // never renders in production, so skip the fetch there entirely.
  const { adapterGarage } = useStationaryGarages({ withCapacity: false, enabled: !isProduction });

  return (
    <EnvBanner
      adapter={
        adapterGarage
          ? {
              adapterType: adapterGarage.adapterType,
              adapterEnv: adapterGarage.adapterEnv
            }
          : null
      }
    />
  );
};
